module.exports = __webpack_public_path__ + "img/image15.9a75f867.jpg";